import { Link as NextLink } from '~i18n/navigation';

import type { CustomLinkProps } from './types';

const isInternal = (href: string): boolean => {
	return href.startsWith('/') || href.startsWith('#');
};

export const SmartLink = ({
	href,
	forceNativeLink = false,
	target,
	rel,
	...rest
}: CustomLinkProps) => {
	if (isInternal(href) && !forceNativeLink) {
		return <NextLink href={href} {...rest} />;
	}
	return (
		<a
			href={href as string}
			{...rest}
			target={target ?? '_blank'}
			rel={rel ?? 'noopener noreferrer'}
		/>
	);
};
